"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProxy = void 0;
const react_1 = require("react");
function useProxy(host, handlerFactory) {
    const handlers = (0, react_1.useMemo)(() => ({}), []);
    return new Proxy(host, {
        get(target, name) {
            let handler = handlers[name];
            if (!handler) {
                handler = handlerFactory(name);
                handlers[name] = handler;
            }
            return handler;
        },
    });
}
exports.useProxy = useProxy;
//# sourceMappingURL=useProxy.js.map